import {tokenDefinition} from "../../token/tokenDefinition.mjs";
import {TokenType} from  "../../token/tokenType.mjs";
import {TokenName} from "./tokenName.mjs";
import {NodeName} from "./nodeName.mjs";
import {Node} from "../../node/node.mjs";
import {TableColumn} from "./tableColumn.mjs";

const tableHeader = tokenDefinition({
  name: TokenName.TABLE_HEADER,
  type: TokenType.DELIMITER,
  tokenMatcher: /^\|[-]+\|?\n/, // match |---- or |----| or |-
  contentMatcher: /^\|[-]+\|?\n/,
});

class TableRow {

  constructor() {
    this.isHeader = false
  }

  consume(tokenIterator, nodeIterator) {
    if(this.isOpening(tokenIterator, nodeIterator)) {
      this.openNewNode(tokenIterator, nodeIterator)
    }
    if(this.isClosing(tokenIterator, nodeIterator)) {
      this.closeNode(tokenIterator, nodeIterator)
    }
  }

  isOpening(tokenIterator, nodeIterator) {
    return nodeIterator.currentParentNode.name === NodeName.TABLE
        && tokenIterator.hasNext(2)
        && tokenIterator.token().name === TokenName.PIPE
        && tokenIterator.peekNext(1) !== TokenName.LINE_FEED
  }

  isClosing(tokenIterator, nodeIterator) {
    return !tokenIterator.token()
        || tokenIterator.isLast()
          && tokenIterator.token().name === TokenName.PIPE
        || (tokenIterator.hasNext(2)
          && tokenIterator.token().name === TokenName.PIPE
          && tokenIterator.peekNext(1).name === TokenName.LINE_FEED)
  }

  openNewNode(tokenIterator, nodeIterator) {
    nodeIterator.addOpenNode(new Node(
        NodeName.TABLE_ROW,
        null,
        new TableRow(),
        nodeIterator.currentParentNode
    ))

    const column = new TableColumn()
    column.openNewNode(tokenIterator, nodeIterator)
  }

  closeNode(tokenIterator, nodeIterator) {

    // find row node and close it
    let openRowNodeIndex = nodeIterator.indexOfLastOpen(NodeName.TABLE_ROW)
    if(openRowNodeIndex === null) return

    if(this.isFollowedByHeaderDelimiter(tokenIterator)) {
      nodeIterator.openNodes[openRowNodeIndex].name = NodeName.TABLE_HEADER
      nodeIterator.closeNodeAtIndex(openRowNodeIndex);

      // eat final pipe and LineFeed
      tokenIterator.eatTokens(3)
    } else {
      nodeIterator.closeNodeAtIndex(openRowNodeIndex);

      // eat final pipe and LineFeed
      tokenIterator.eatTokens(2)
    }

    if(this.isFollowedByHeaderDelimiter(tokenIterator)) {
      nodeIterator.
      this.nodeName = true
      tokenIterator.eatTokens(1)
    }
  }

  isFollowedByHeaderDelimiter(tokenIterator) {
    return tokenIterator.hasNext(3)
    && tokenIterator.token().name === TokenName.PIPE
    && tokenIterator.peekNext(1).name === TokenName.LINE_FEED
    && tokenIterator.peekNext(2).name === TokenName.TABLE_HEADER
  }

  toHtml(node, toHtml, idProvider) {
    var content = ""
    for(const child of node.children) {
      content += toHtml(child, idProvider)
    }

    return "<tr>" + content + "</tr>"
  }

  onEndOfMarkup(openNode) {
    openNode.close()
  }

}
export {TableRow, tableHeader}